(() => {
  if (customElements.get('moebe-grid-sort')) return;
  let counter = 0;
  class MoebeGridSort extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.querySelector('.moebe-sort-picker')?.remove();
      const select = this.querySelector('select');
      if (!select) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const picker = document.createElement('div');
      picker.className = 'moebe-sort-picker';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'moebe-sort-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const value = document.createElement('span');
      value.id = 'moebe-sort-value-' + (++counter);
      const label = this.querySelector('label');
      if (label) {
        label.id = 'moebe-sort-label-' + counter;
        trigger.setAttribute('aria-labelledby', label.id + ' ' + value.id);
      }
      trigger.append(value);
      trigger.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 28 16" aria-hidden="true"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" fill="none" stroke="currentColor" stroke-width="1.5" vector-effect="non-scaling-stroke"/></svg>');
      const list = document.createElement('div');
      list.className = 'moebe-sort-options';
      list.id = 'moebe-sort-options-' + counter;
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', label?.textContent || '');
      list.hidden = true;
      trigger.setAttribute('aria-controls', list.id);
      const entries = Array.from(select.options).filter(option => !option.disabled && !option.hidden).map(option => {
        const entry = document.createElement('button');
        entry.type = 'button';
        entry.className = 'moebe-sort-option';
        entry.tabIndex = -1;
        entry.setAttribute('role', 'option');
        entry.dataset.value = option.value;
        entry.textContent = option.textContent;
        entry.addEventListener('click', () => {
          select.value = option.value;
          sync();
          close();
          trigger.focus();
          select.dispatchEvent(new Event('change', {bubbles: true}));
        }, options);
        list.append(entry);
        return entry;
      });
      const sync = () => {
        value.textContent = this.dataset.triggerLabel || select.selectedOptions[0]?.textContent || '';
        entries.forEach(entry => entry.setAttribute('aria-selected', String(entry.dataset.value === select.value)));
      };
      const close = () => { list.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
      const open = () => {
        sync();
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        (entries.find(entry => entry.dataset.value === select.value) || entries[0])?.focus();
      };
      trigger.addEventListener('click', () => list.hidden ? open() : close(), options);
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {event.preventDefault(); open();}
      }, options);
      let typed = '', typedAt = 0;
      picker.addEventListener('keydown', event => {
        if (event.key === 'Escape') {event.preventDefault(); close(); trigger.focus(); return;}
        const index = entries.indexOf(document.activeElement);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % entries.length;
        if (event.key === 'ArrowUp') next = (index - 1 + entries.length) % entries.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = entries.length - 1;
        if (next !== undefined) {event.preventDefault(); entries[next].focus();}
        if (event.key === 'Tab') {close(); trigger.focus();}
        if (event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.metaKey && !event.altKey) {
          typed = (Date.now() - typedAt < 600 ? typed : '') + event.key.toLowerCase();
          typedAt = Date.now();
          entries.find(entry => entry.textContent.trim().toLowerCase().startsWith(typed))?.focus();
        }
      }, options);
      picker.addEventListener('focusout', event => {if (!picker.contains(event.relatedTarget)) close();}, options);
      document.addEventListener('pointerdown', event => {if (!picker.contains(event.target)) close();}, options);
      select.addEventListener('change', event => {
        sync();
        if (this.hasAttribute('data-category-navigation')) {
          event.stopPropagation();
          const target = new URL(select.value, window.location.origin);
          if (target.origin === window.location.origin) window.location.assign(target.href);
        }
      }, options);
      picker.append(trigger, list);
      this.append(picker);
      select.hidden = true;
      sync();
    }
    disconnectedCallback() {this.controller?.abort();}
  }
  customElements.define('moebe-grid-sort', MoebeGridSort);
})();
